import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

import { PersonalityData } from "../types/personalityData";

interface Params {
  signal?: AbortSignal;
}

export const fetchList = createAsyncThunk<PersonalityData[], Params, ThunkConfig<ApiError>>(
  "personality/fetchList",
  async ({ signal }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<PersonalityData[]>("/api/personalities", { signal });

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
